﻿module.exports = function ($, mustache, urlParameters, addToCollection) {
    return {
        results: null,
        init: function () {
            var isSearchPage = $('section.siteSearch').length > 0;
            if (isSearchPage) {
                this.initForm();
                this.initTabs();
            }
        },
        initForm: function () {
            var self = this; // Used to reference 'this' inside anonymous functions (e.g. click events)
            var keywords = urlParameters.param('keywords');
            var page = urlParameters.param('page') || 1;
            var resultsPerPage = urlParameters.param('results') || 10;

            // Set the initial form values
            $('#keywords').val(keywords);
            $('.siteSearch__searchTerms').text(keywords);
            $('#page').val(page);
            $('#resultsPerPage').val(resultsPerPage);

            // Set focus to search bar if on page, otherwise load search page
            $(".generalSearchBar__search a").click(function (e) {
                e.preventDefault();
                // Get new results
                self.search();
            });

            // Create change events.
            $('#keywords').keyup(function (e) {

                if (e.keyCode == '13') {
                    $('body').removeClass('search-filters-active');
                }

                // Update the you searched label
                $('.siteSearch__searchTerms').text($("#keywords").val());
                // Get new results
                self.search();
            });

            // Create select change events.
            $('#searchWebsites').change(function () {
                // if selection is not equal to current website.
                if ($(this).val() != "/")
                    window.location = $(this).val() + "search?keywords=" + $('#keywords').val();
            });
            
            $('#resultsPerPage').change(function () {
                // Reset the page number to 1
                $('#page').val(1);
                // Get new results
                self.search();
            });
      

            // Set the click events on the previous and next buttons
            $('.siteSearch__results__pagination .prev').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var page = parseInt($('#page').val()) - 1;
                if (page > 0) {
                    $('#page').val(page);
                    self.search();
                }
            });
            $('.siteSearch__results__pagination .next').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var page = parseInt($('#page').val()) + 1;
                if (page <= $('#pagination').data('pages')) {
                    $('#page').val(page);
                    self.search();
                }
            });

            // On first load get results.
            this.search();

            // Listen for back events that don't trigger a reload and force a reload
            window.addEventListener('popstate', function(e) {
                //alert('here');
                //self.initForm();
            });
        },
        initTabs: function () {
            var self = this;
            $(".siteSearch__tabs a").click(function (e) {
                e.preventDefault();
                // Reload results with type filter.
                $('#contentType').val($(this).attr("data-contentType"));
                self.search();
                var target = $(this).attr('data-target');
                if (target && target != '') {
                    $('.siteSearch__tabs__tab').removeClass('selected');
                    $(this).parent().addClass('selected');
                    $('.siteSearch__tabContent').hide();
                    $(target).show();
                }
            });
        },
        search: function () {
            // Update the URL with the parameters
            urlParameters.addParam('keywords', $("#keywords").val());
            urlParameters.addParam('page', $("#page").val());
            urlParameters.addParam('results', $("#resultsPerPage").val());

            // Perform and ajax search
            $.ajax({
                url: '/umbraco/Api/searchapi/General',
                type: 'POST',
                traditional: true,
                data: {
                    keywords: $('#keywords').val(),
                    skip: ($("#page").val() - 1) * $("#resultsPerPage").val(),
                    take: $("#resultsPerPage").val(),
                    websiteId: $("#websiteId").val(),
                    contentType: $('#contentType').val()
                },
                context: this,
                success: this.loadResults,
                error: function () {
                    //console.log("An error occurred when searching.");
                }
            });
        },
        loadResults: function (jsonData) {
            var self = this; // Used to reference 'this' inside anonymous functions (e.g. click events)
            // Reformat the dates
            jsonData.results.forEach(function (result) {
                result.lastUpdated = new Date(result.lastUpdated).toISOString().replace(/^(\d*)-(\d*)-(\d*).*$/, '$3/$2/$1');
            });

            // Load the results
            var results = $('#resultsList');
            results.empty();
            var template = $('#results > script').html();
            mustache.parse(template);
            var rendered = mustache.render(template, { items: jsonData.results });
            results.html(rendered);

            // Set the result counts
            if (jsonData.count > 0 && jsonData.skip < jsonData.count) {
                var resultsStart = jsonData.skip + 1;
                var resultsEnd = jsonData.skip + jsonData.results.length;
                $('.siteSearch__results__header__count--value').text(resultsStart + '-' + resultsEnd + ' of ' + jsonData.count);

                // Build the pagination links
                var resultsPerPage = $("#resultsPerPage").val() || 10;
                var pages = Math.ceil(jsonData.count / resultsPerPage);
                var selectedPage = ((resultsStart - 1) / resultsPerPage) + 1;
                var startPage = Math.max(selectedPage - 3, 1);
                var endPage = Math.min(selectedPage + 3, pages);
                if (selectedPage <= 3) endPage = Math.min(endPage + (4 - selectedPage), pages);
                if (selectedPage > pages - 3) startPage = Math.max(pages - 6, 1);
                $('#pagination').empty();
                $('#pagination').data('pages', pages);
                for (var page = startPage; page <= endPage; page++) {
                    var selected = (page - 1) * resultsPerPage == resultsStart - 1;
                    $('#pagination').append('<a href="#' + page + '" class="pagination__link ' + (selected ? 'selected' : '') + '">' + (page < 10 ? "0" + page : page) + '</a>');
                }
                $('.siteSearch__results__pagination').show();
                $('#pagination .pagination__link').click(function (e) {
                    e.preventDefault();
                    if (!$(this).hasClass('selected')) {
                        $('#page').val($(this).attr('href').replace('#', ''));
                        self.search();
                    }
                });

                // Show the results
                $('.siteSearch__results__footer').css('visibility', 'visible');
                $('#resultsPerPage').show();

                // Bind the Add to Collection events
                addToCollection.bindEvents();
            } else {
                $('.siteSearch__results__header__count--value').text('Your search returned no results.');
                $('.siteSearch__results__footer').css('visibility', 'hidden');
                $('#resultsPerPage').hide();
            }
            $('.siteSearch__results__header').css('display', 'flex');

            // Scroll to the top of the results
            $('html, body').animate({
                scrollTop: 0
            }, 500);
        }
    };
};